var map = {
	"./da.json": [
		1948,
		644
	],
	"./de.json": [
		1949,
		645
	],
	"./en.json": [
		662
	],
	"./es.json": [
		1950,
		646
	],
	"./fr.json": [
		1951,
		647
	],
	"./it.json": [
		1952,
		649
	],
	"./ko.json": [
		1953,
		650
	],
	"./nl.json": [
		1954,
		651
	],
	"./pl.json": [
		1955,
		652
	],
	"./pt.json": [
		1956,
		653
	],
	"./ru.json": [
		1957,
		654
	],
	"./zh.json": [
		1958,
		655
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 986;
module.exports = webpackAsyncContext;